import Prism from 'prismjs'
import React, {HTMLProps} from 'react'
import 'prismjs/components/prism-jsx.min'

const useLayoutEffect =
  typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect

export default function CodeBlock(props: HTMLProps<HTMLPreElement>) {
  const ref = React.useRef<HTMLPreElement>(null)

  useLayoutEffect(() => {
    ref.current && Prism.highlightAllUnder(ref.current)
  }, [ref])

  return <pre ref={ref} {...props} className="rounded-lg" />
}